import { render, staticRenderFns } from "./mapform.vue?vue&type=template&id=b04e91ca&scoped=true&"
import script from "./mapform.vue?vue&type=script&lang=js&"
export * from "./mapform.vue?vue&type=script&lang=js&"
import style0 from "./mapform.vue?vue&type=style&index=0&id=b04e91ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04e91ca",
  null
  
)

export default component.exports